import React, { Component } from "react";
import BrowserHistoryDispatcher from "dispatchers/browser-history-dispatcher";
import EditorApp from "editor/editor-main";
import { withRouter } from "react-router-dom";
import Spinner from "util/components/spinner";
import { H2 } from "visual-components/util/texts";

class EditContent extends Component {
  componentDidMount() {
    document.title = "Edit Content - DojoMojo";
  }

  selectTemplate = () => {
    BrowserHistoryDispatcher.push(`/builder/${this.props.currentCampaign.id}/select-template`);
  };

  render() {
    const campaign = this.props.currentCampaign;

    if (campaign.loading) {
      return <Spinner />;
    }

    return (
      <div
        className="container"
        style={{
          backgroundColor: "white",
          width: "100%",
          // Override Bootstrap's `.container` 960px cap + auto-centering so the
          // preview uses the full canvas instead of a narrow column.
          maxWidth: "none",
          marginLeft: "0px",
          marginRight: "0px",
          paddingLeft: "0px",
          paddingRight: "0px",
          marginTop: "155px",
        }}
      >
        {campaign.desktopElements && campaign.desktopElements.landerVersion ? (
          <EditorApp
            campaignId={campaign.id}
            openToMobile={this.props.location.search === "?mobile"}
          />
        ) : (
          <div
            style={{
              paddingTop: "200px",
              textAlign: "center",
            }}
          >
            <div
              onClick={this.selectTemplate}
              style={{
                cursor: "pointer",
              }}
            >
              <H2>Click Here to Select a Template</H2>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default withRouter(EditContent);
